module.exports = __webpack_public_path__ + "static/img/U16.57707d8b.png";